class SocialSecurityService {

  constructor(userDataService, AuthenticationService) {
    'ngInject';
    this.userDataService = userDataService;
    this.employeeId = AuthenticationService.getEmployeeId();
  }

  initData() {
    if (!this.userDataService.isEmpty()) {
      return this.userDataService.getEmployee();
    }

    this.userDataService.setEmployee(this.employeeId);
  }
}

export default SocialSecurityService;



// WEBPACK FOOTER //
// ./client/app/social-security.module/common/services/social-security.service.js